<template>
	<h2 v-text="category.category_name" class="heading2"></h2>
	<div class="more">
		<a v-bind:href="category.category_link" target="_blank"><i class="glyphicon glyphicon-arrow-right"></i> 一覧を見る</a>
	</div>
	<ul class="linkList">
		<li v-for="subcategory in category.subcategories">
			<a v-bind:href="subcategory.category_link" target="_blank">
				<div class="flexColumn">
					<!-- <div class="flexColumn__col1">
						<img v-bind:src="subcategory.eyecatch" class="img-responsive" alt="">
					</div> -->
					<div class="flexColumn__col2">
						<h3 v-text="subcategory.category_name" class="heading3"></h3>
					</div>
				</div>
			</a>
		</li>
	</ul>

	<!-- <div v-on:click="debug">debug</div> -->
</template>

<script>
module.exports = {
	data: function () {
		return {
			category: [],
			reload: {
				times: 3,
				delay: 5000
			}
		};
	},
	ready: function(){
		// GET request
		var host = (document.location.protocol === 'https:') ? 'https:' : 'http:';
		var hostname = document.location.hostname;
		var url = this.$route.devmode ? 'https://studio.powerpage.jp' : host + '//' + hostname;
		url = url + '/contents/wp-json/ras/subcategories';

		// this.$http.get(url).then(function(response) {
		// 	// success callback
		// 	// console.log(response.statusText);
		// 	var json = response.data;
		// 	this.$set('category', json[0]);
		// }, function (response) {
		// 	// error callback
		// 	console.log(response.statusText);
		// 	console.log('データの取得に失敗しました');
		// });
		this.getJson(url);
	},
	methods: {
		debug: function(){
			console.log(this.$data.features);
		},
		getJson: function(url, times = this.reload.times, delay = this.reload.delay){
			this.$http.get(url).then(function(response) {
				// success callback
				// console.log(response.statusText);
				var json = response.data;
				this.$set('category', json[0]);
			}, function (response) {
				// error callback
				console.log(response.statusText);
				console.log('データの取得に失敗しました');
				if (times > 0){
					setTimeout(this.getJson, delay, url, times - 1, delay);
				}
			});
		}
	}
};
</script>

<style scoped lang="scss">
.flexColumn{
	.flexColumn__col1{
		width: 80px;
	}
}
</style>



// WEBPACK FOOTER //
// subcategories.vue?44d5b4ae